// removed by extract-text-webpack-plugin
module.exports = {"sm":"only screen and (min-width: 48em)","xsmall":"only screen and (min-width: 375px)","small":"only screen and (min-width: 481px)","medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","xlarge":"only screen and (min-width: 1201px)","personal":"personal-FLzPI","statsContainer":"statsContainer-a6_Yn","profile":"profile-M_GwM","stats":"stats-3kKWy","stat":"stat-2SYEK","statValue":"statValue-rkWBq","statUnit":"statUnit-1VWq2","icon":"icon-1w75J","socialLinks":"socialLinks-Yof4t"};


//////////////////
// WEBPACK FOOTER
// ./src/components/yearInReview/2018/midyear/PersonalProgress/_personalProgress2018.css
// module id = 1296
// module chunks = 1